import { Box, Typography } from '@mui/material'

import { PackageTypes } from 'constants/Packaging'
import { BookingAddress } from 'generated/graphql'

interface LegalDocumentsProps {
  ourReference?: string,
  bookingCurrentAction?: BookingAddress | null
  nextBookingAction?: BookingAddress | null
}

const containerStyles = {
  p: 2,
  mb: 2,
  borderBottom: '2px solid #F6F4F4',
}

const titleStyles = {
  color: '#333',
  fontSize: '18px',
  fontWeight: 600,
  mb: 0.5,
}

const idStyles = {
  color: '#666',
  fontSize: '14px',
  fontWeight: 400,
}

export const LegalDocuments = ({ ourReference, bookingCurrentAction, nextBookingAction }: LegalDocumentsProps) => {
  const deliveryAllocations = nextBookingAction?.allocations ?? []
  const deliveryAddressPackages = nextBookingAction?.addressPackages ?? []
  const pickupAddressPackages = bookingCurrentAction?.addressPackages ?? []

  const packages = deliveryAllocations.length > 0
    ? deliveryAllocations
    : deliveryAddressPackages.length > 0
      ? deliveryAddressPackages
      : pickupAddressPackages

  const pkg = packages[0]?.package
  const packageName = (pkg?.type && PackageTypes[pkg.type]) || PackageTypes.PACKAGES

  return (
    <Box sx={containerStyles}>
      <Typography variant='h6' sx={titleStyles}>
        {packageName}
      </Typography>

      <Typography variant='body2' sx={idStyles}>
        {ourReference}
      </Typography>
    </Box>
  )
}
